import { repositories } from '../repositories';
import type { SWCustomer, SWSyncState, SWActivityStats } from '../repositories/SuccessWareRepository';

export class SuccessWareService {
  async getActivityStats(): Promise<SWActivityStats> {
    return await repositories.successWare.getActivityStats();
  }

  async getRecentActivity(limit: number = 50): Promise<SWCustomer[]> {
    return await repositories.successWare.getRecentActivity(limit);
  }

  async getSyncStates(): Promise<SWSyncState[]> {
    return await repositories.successWare.getSyncStates();
  }
}

export const successWareService = new SuccessWareService();
